<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>
                    <span v-if="editMode">Urejanje evidence opravljenega prostovoljskega dela</span>
                    <span v-if="!editMode">Dodajanje zapisa v evidenco opravljenega prostovoljskega dela</span>
                </h1>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <b-form-group
                        label="Izberi datum"
                        label-for="date"
                        :class="{'is-invalid': errors.has('date')}">

                    <VueCtkDateTimePicker id="date" name="date" format="YYYY-MM-DDTHH:mm:ssZ" class="withLabel"
                                          locale="sl"
                                          formatted="dddd, Do MMMM YYYY" :onlyDate="true"
                                          label="Datum"
                                          :disabled="readonly"
                                          :noClearButton="readonly"
                                          :class="readonly ? 'disabled' : ''"
                                          v-model="volunteerWorkHoursReport.date"
                                          v-validate="'required'"/>
                    <div class="invalid-feedback" v-if="errors.has('date')">
                        Polje ne sme biti prazno.
                    </div>
                </b-form-group>

                <b-form-group
                        label="Ali je bilo opravljeno prostovoljsko delo izvedeno v sklopu projekta Zavoda Dobra pot?">
                    <div>
                        <b-form-checkbox
                                v-model="volunteerWorkHoursReport.isPartOfaProject"
                                size="lg"
                                :disabled="readonly"
                                switch> prostovoljsko delo v sklopu projekta
                        </b-form-checkbox>
                    </div>
                </b-form-group>

                <b-form-group
                        v-if="volunteerWorkHoursReport.isPartOfaProject"
                        label="Določi v kater projekt sodi zapis (lahko izberete več projektov)"
                        label-for="project"
                        :class="{'is-invalid': errors.has('project')}">

                    <v-select
                            v-model="volunteerWorkHoursReport.project"
                            placeholder="projekt"
                            id="project"
                            name="project"
                            multiple
                            :options="projects"
                            label="name"
                            :disabled="readonly"
                            :reduce="item => item.id"
                            v-validate="'required'"
                    >
                        <span slot="no-options">Ni zadetkov.</span>
                        <template slot="option" slot-scope="item">
                            {{item.name}}
                        </template>
                        <template slot="selected-option" slot-scope="item">
                            {{item.name}}
                        </template>

                    </v-select>
                    <div class="invalid-feedback" v-if="errors.has('project')">
                        Polje ne sme biti prazno.
                    </div>
                </b-form-group>

                <b-form-group
                        v-if="!volunteerWorkHoursReport.isPartOfaProject"
                        label="Opiši za katero aktivnost gre (npr. oblikovanje, promocija, urejanje spletne strani)"
                        label-for="otherActivityDescription"
                        :class="{'is-invalid': errors.has('otherActivityDescription')}">

                    <b-form-input id="otherActivityDescription"
                                  name="otherActivityDescription"
                                  v-model="volunteerWorkHoursReport.otherActivityDescription"
                                  placeholder="opis aktivnosti"
                                  type="text"
                                  :disabled="readonly"
                                  v-validate="validationRulePartOfaProject"
                                  trim></b-form-input>

                    <div class="invalid-feedback" v-if="errors.has('otherActivityDescription')">
                        Polje ne sme biti prazno.
                    </div>

                </b-form-group>

                <b-form-group
                        id="addressName"
                        label="Vnesi naziv lokacije, kjer je bilo prostovoljsko delo opravljeno (npr. Delezova domačija / sedež zavoda / delo od doma)"
                        label-for="addressName"
                        :class="{'is-invalid': errors.has('addressName')}">
                    <b-form-input
                            id="addressName"
                            name="addressName"
                            v-model="volunteerWorkHoursReport.addressName"
                            placeholder="naziv lokacije"
                            v-validate="'required'"
                            :disabled="readonly"
                            trim></b-form-input>
                    <div class="invalid-feedback" v-if="errors.has('addressName')">
                        Polje ne sme biti prazno.
                    </div>
                </b-form-group>

                <b-form-group
                        id="municipality"
                        label="Vnesi naziv občine, kjer je bilo prostovoljsko delo opravljeno"
                        label-for="municipality"
                        :class="{'is-invalid': errors.has('municipality')}">
                    <b-form-input id="municipality" name="municipality"
                                  v-model="volunteerWorkHoursReport.municipality" placeholder="naziv občine"
                                  v-validate="'required'" :disabled="readonly" trim></b-form-input>
                    <div class="invalid-feedback" v-if="errors.has('municipality')">
                        Polje ne sme biti prazno.
                    </div>
                </b-form-group>

                <div class="card bg-light p-3 mt-4 mb-4 organizationalWorkSection">

                    <b-form-group
                            label="Ali opravljeno delo sodi v ORGANIZACIJSKO prostovoljsko delo?">
                        <div>
                            <b-form-checkbox
                                    v-model="volunteerWorkHoursReport.isOrganizationalWork"
                                    size="lg"
                                    :disabled="readonly"
                                    switch> organizacijsko prostovoljsko delo
                            </b-form-checkbox>
                        </div>
                    </b-form-group>


                    <div class="organizationalWorkSectionFormItems"
                         v-if="volunteerWorkHoursReport.isOrganizationalWork">


                        <b-form-group
                                label="Vnesi količino opravljenega organizacijskega prostovoljskega dela"
                                label-for="organizationalWorkHours"
                                :class="{'is-invalid': errors.has('organizationalWorkHours') ||  errors.has('organizationalWorkMinutes')}">


                            <div class="row">
                                <div class="col-md-4">
                                    <b-input-group append="ur">
                                        <v-select
                                                style="width: 80%"
                                                v-model="volunteerWorkHoursReport.organizationalWorkHours"
                                                placeholder="št. ur"
                                                id="organizationalWorkHours"
                                                name="organizationalWorkHours"
                                                :disabled="readonly"
                                                :options="['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']"
                                                v-validate="validationRuleOrganizationalWork"
                                        >
                                            <span slot="no-options">Ni zadetkov.</span>
                                        </v-select>
                                    </b-input-group>
                                    <div class="invalid-feedback" v-if="errors.has('organizationalWorkHours')">
                                        Polje ne sme biti prazno.
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <b-input-group append="min">
                                        <v-select
                                                style="width: 80%"
                                                v-model="volunteerWorkHoursReport.organizationalWorkMinutes"
                                                placeholder="št. minut"
                                                id="organizationalWorkMinutes"
                                                name="organizationalWorkMinutes"
                                                :disabled="readonly"
                                                :options="['0', '15', '30', '45']"
                                                v-validate="validationRuleOrganizationalWork"
                                        >
                                            <span slot="no-options">Ni zadetkov.</span>
                                        </v-select>
                                    </b-input-group>
                                    <div class="invalid-feedback" v-if="errors.has('organizationalWorkMinutes')">
                                        Polje ne sme biti prazno.
                                    </div>
                                </div>
                            </div>


                        </b-form-group>

                        <b-form-group
                                label="Opišite opravljeno organizacijsko prostovoljsko delo"
                                label-for="organizationalWorkNotes"
                                :class="{'is-invalid': errors.has('organizationalWorkNotes')}">
                                                <textarea v-model="volunteerWorkHoursReport.organizationalWorkNotes"
                                                          id="organizationalWorkNotes"
                                                          name="organizationalWorkNotes"
                                                          placeholder="opis opravljenega organizacijskega prostovoljskega dela"
                                                          class="form-control" style="height: auto"
                                                          :disabled="readonly"
                                                          :class="readonly ? 'disabled' : ''"
                                                          required rows="5"
                                                          v-validate="validationRuleOrganizationalWork"> </textarea>
                            <div class="invalid-feedback" v-if="errors.has('organizationalWorkNotes')">
                                Polje ne sme biti prazno.
                            </div>
                        </b-form-group>

                    </div>

                </div>

                <div class="card bg-light p-3 mb-4 domainWorkSection">

                    <b-form-group
                            label="Ali opravljeno delo sodi v VSEBINSKO prostovoljsko delo?">
                        <div>
                            <b-form-checkbox
                                    v-model="volunteerWorkHoursReport.isDomainWork"
                                    size="lg"
                                    :disabled="readonly"
                                    switch> vsebinsko prostovoljsko delo
                            </b-form-checkbox>
                        </div>
                    </b-form-group>

                    <div class="domainWorkSectionFormItems" v-if="volunteerWorkHoursReport.isDomainWork">

                        <b-form-group
                                label="Vnesi količino opravljenega vsebinskega prostovoljskega dela"
                                label-for="domainWorkHours"
                                :class="{'is-invalid': errors.has('domainWorkHours')}">

                            <div class="row">
                                <div class="col-md-4">
                                    <b-input-group append="ur">
                                        <v-select
                                                style="width: 80%"
                                                v-model="volunteerWorkHoursReport.domainWorkHours"
                                                placeholder="št. ur"
                                                id="domainWorkHours"
                                                name="domainWorkHours"
                                                :disabled="readonly"
                                                :options="['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']"
                                                v-validate="validationRuleDomainWork"
                                        >
                                            <span slot="no-options">Ni zadetkov.</span>
                                        </v-select>
                                    </b-input-group>
                                    <div class="invalid-feedback" v-if="errors.has('domainWorkHours')">
                                        Polje ne sme biti prazno.
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <b-input-group append="min">
                                        <v-select
                                                style="width: 80%"
                                                v-model="volunteerWorkHoursReport.domainWorkMinutes"
                                                placeholder="št. minut"
                                                id="domainWorkMinutes"
                                                name="domainWorkMinutes"
                                                :disabled="readonly"
                                                :options="['0', '15', '30', '45']"
                                                v-validate="validationRuleDomainWork"
                                        >
                                            <span slot="no-options">Ni zadetkov.</span>
                                        </v-select>
                                    </b-input-group>
                                    <div class="invalid-feedback" v-if="errors.has('domainWorkMinutes')">
                                        Polje ne sme biti prazno.
                                    </div>
                                </div>
                            </div>


                        </b-form-group>

                        <b-form-group
                                label="Opišite opravljeno vsebinsko prostovoljsko delo"
                                label-for="domainWorkNotes"
                                :class="{'is-invalid': errors.has('domainWorkNotes')}">
                                            <textarea v-model="volunteerWorkHoursReport.domainWorkNotes"
                                                      id="domainWorkNotes"
                                                      name="domainWorkNotes"
                                                      placeholder="opis opravljenega vsebinskega prostovoljskega dela"
                                                      class="form-control" style="height: auto"
                                                      :disabled="readonly"
                                                      :class="readonly ? 'disabled' : ''"
                                                      required rows="5"
                                                      v-validate="validationRuleDomainWork"> </textarea>
                            <div class="invalid-feedback" v-if="errors.has('domainWorkNotes')">
                                Polje ne sme biti prazno.
                            </div>
                        </b-form-group>

                    </div>

                </div>

                <div class="card bg-light p-3 otherWorkSection">

                    <b-form-group
                            label="Ali opravljeno delo sodi v DRUGO prostovoljsko delo?">
                        <div>
                            <b-form-checkbox
                                    v-model="volunteerWorkHoursReport.isOtherWork"
                                    size="lg"
                                    :disabled="readonly"
                                    switch> drugo prostovoljsko delo
                            </b-form-checkbox>
                        </div>
                    </b-form-group>

                    <div class="otherWorkSectionFormItems" v-if="volunteerWorkHoursReport.isOtherWork">

                        <b-form-group
                                label="Vnesi količino opravljenega drugega prostovoljskega dela"
                                label-for="domainWorkHours"
                                :class="{'is-invalid': errors.has('otherWorkHours')}">

                            <div class="row">
                                <div class="col-md-4">
                                    <b-input-group append="ur">
                                        <v-select
                                                style="width: 80%"
                                                v-model="volunteerWorkHoursReport.otherWorkHours"
                                                placeholder="št. ur"
                                                id="otherWorkHours"
                                                name="otherWorkHours"
                                                :disabled="readonly"
                                                :options="['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']"
                                                v-validate="validationRuleOtherWork"
                                        >
                                            <span slot="no-options">Ni zadetkov.</span>
                                        </v-select>
                                    </b-input-group>
                                    <div class="invalid-feedback" v-if="errors.has('otherWorkHours')">
                                        {{errors.first('otherWorkHours') }}
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <b-input-group append="min">
                                        <v-select
                                                style="width: 80%"
                                                v-model="volunteerWorkHoursReport.otherWorkMinutes"
                                                placeholder="št. minut"
                                                id="otherWorkMinutes"
                                                name="otherWorkMinutes"
                                                :disabled="readonly"
                                                :options="['0', '15', '30', '45']"
                                                v-validate="validationRuleOtherWork"
                                        >
                                            <span slot="no-options">Ni zadetkov.</span>
                                        </v-select>
                                    </b-input-group>
                                    <div class="invalid-feedback" v-if="errors.has('otherWorkMinutes')">
                                        Polje ne sme biti prazno.
                                    </div>
                                </div>
                            </div>


                        </b-form-group>

                        <b-form-group
                                label="Opišite opravljeno drugo prostovoljsko delo"
                                label-for="otherWorkNotes"
                                :class="{'is-invalid': errors.has('otherWorkNotes')}">
                                            <textarea v-model="volunteerWorkHoursReport.otherWorkNotes"
                                                      id="otherWorkNotes"
                                                      name="otherWorkNotes"
                                                      placeholder="opis opravljenega drugega prostovoljskega dela"
                                                      class="form-control" style="height: auto"
                                                      :disabled="readonly"
                                                      :class="readonly ? 'disabled' : ''"
                                                      required rows="5"
                                                      v-validate="validationRuleOtherWork"> </textarea>
                            <div class="invalid-feedback" v-if="errors.has('otherWorkNotes')">
                                Polje ne sme biti prazno.
                            </div>
                        </b-form-group>

                    </div>

                </div>


            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mt-3">
                <div class="d-flex">
                    <button v-if="editMode" class="btn btn-danger mr-auto" @click="deleteWorkHoursReportConfirmation()">
                        <i class="fa fa-trash"></i>
                        Izbriši
                        zapis
                    </button>

                    <button v-if="!editMode" type="submit" @click="addWorkHoursReport()" class="btn btn-info ml-auto"><i
                            class="fa fa-save"></i> Shrani podatke
                    </button>


                    <button v-if="editMode" type="submit" @click="updateWorkHoursReport()" class="btn btn-info ml-auto">
                        <i
                                class="fa fa-save"></i> Posodobi podatke
                    </button>
                </div>

                <div>

                    <router-link :to="{ name: 'VolunteerWorkHoursReport'}" class="btn btn-link pt-4">
                        Prekliči
                    </router-link>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import firebase from 'firebase'
  import {db} from '../../main'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'

  export default {
    name: 'EditVolunteerWorkHours',
    components: {
      vSelect
    },
    data () {
      return {
        users: this.$store.getters.getUsers,
        projects: this.$store.getters.getProjects,
        volunteerWorkHoursReport: {
          id: '',
          userId: '',
          date: null,
          isPartOfaProject: true,
          project: null,
          otherActivityDescription: '',
          addressName: '',
          municipality: '',

          isOrganizationalWork: false,
          organizationalWorkHours: 0,
          organizationalWorkMinutes: 0,
          organizationalWorkNotes: '',

          isDomainWork: false,
          domainWorkHours: 0,
          domainWorkMinutes: 0,
          domainWorkNotes: '',

          isOtherWork: false,
          otherWorkHours: 0,
          otherWorkMinutes: 0,
          otherWorkNotes: '',

          createdBy: '',
          createdAt: null,
          updatedBy: '',
          updatedAt: null
        },
        id: this.$route.params.id,
        readonly: this.$route.params.readonly,
        editMode: false
      }
    },

    computed: {
      validationRulePartOfaProject () {
        return this.volunteerWorkHoursReport.isPartOfaProject === false ? 'required' : ''
      },
      validationRuleOrganizationalWork () {
        return this.volunteerWorkHoursReport.isOrganizationalWork ? 'required' : ''
      },
      validationRuleDomainWork () {
        return this.volunteerWorkHoursReport.isDomainWork ? 'required' : ''
      },
      validationRuleOtherWork () {
        return this.volunteerWorkHoursReport.isOtherWork ? 'required' : ''
      }
    },

    mounted () {
      const _this = this

      if (_this.$store.getters.getUsers.length === 0) {
        _this.$store.dispatch('retrieveUsers').then(() => {
          _this.users = _this.$store.getters.getUsers

        })
      }

      if (_this.$store.getters.getProjects.length === 0) {
        _this.$store.dispatch('retrieveProjects').then(() => {
          _this.projects = _this.$store.getters.getProjects
        })
      }

      if (this.id) {
        this.editMode = true
        this.retrieveWorkHoursReport()
      } else {
        this.editMode = false
        this.volunteerWorkHoursReport.date = this.moment().format('YYYY-MM-DDTHH:mm:ssZ')
        this.volunteerWorkHoursReport.startTime = this.moment().set({hour: 8, minute: 0}).format('HH:mm')
        this.volunteerWorkHoursReport.endTime = this.moment().set({hour: 16, minute: 0}).format('HH:mm')
        this.volunteerWorkHoursReport.type = 'redno delo'
        this.volunteerWorkHoursReport.userId = JSON.parse(sessionStorage.getItem('DP_user')).id
        this.calculateDuration()
      }

      console.log('volunteerWorkHoursReport ->', this.volunteerWorkHoursReport)

    },
    methods: {

      getOptionLabel (option) {
        //console.log(option);
        return this.getReadableUser(option.id)
      },

      retrieveWorkHoursReport () {
        const _this = this

        db.collection('volunteerWorkHoursReports')
          .doc(this.id)
          .get()
          .then(snapshot => {
            const document = snapshot.data()

            _.forOwn(document, function (value, key) {
              if (key === 'date') {
                document[key] = _this.moment.unix(value.seconds).format('YYYY-MM-DDTHH:mm:ssZ')
              } else if (key === 'startTime' || key === 'endTime') {
                document[key] = _this.moment.unix(value.seconds).format('HH:mm')
              }
            })

            _this.volunteerWorkHoursReport = document

          })
      },

      updateWorkHoursReport (id) {
        const _this = this
        const currentWorkHoursReport = db.collection('volunteerWorkHoursReports').doc(this.id)

        this.$validator.validate().then(result => {
          if (result) {
            return currentWorkHoursReport.update({
              userId: _this.volunteerWorkHoursReport.userId,
              date: _this.moment(_this.volunteerWorkHoursReport.date).toDate(),
              isPartOfaProject: _this.volunteerWorkHoursReport.isPartOfaProject,
              project: _this.volunteerWorkHoursReport.isPartOfaProject ? _this.volunteerWorkHoursReport.project : '',
              otherActivityDescription: !_this.volunteerWorkHoursReport.isPartOfaProject ? _this.volunteerWorkHoursReport.otherActivityDescription : '',
              addressName: _this.volunteerWorkHoursReport.addressName,
              municipality: _this.volunteerWorkHoursReport.municipality,

              isOrganizationalWork: _this.volunteerWorkHoursReport.isOrganizationalWork,
              organizationalWorkHours: _this.volunteerWorkHoursReport.isOrganizationalWork ? _this.volunteerWorkHoursReport.organizationalWorkHours : 0,
              organizationalWorkMinutes: _this.volunteerWorkHoursReport.isOrganizationalWork ? _this.volunteerWorkHoursReport.organizationalWorkMinutes : 0,
              organizationalWorkNotes: _this.volunteerWorkHoursReport.isOrganizationalWork ? _this.volunteerWorkHoursReport.organizationalWorkNotes : '',

              isDomainWork: _this.volunteerWorkHoursReport.isDomainWork,
              domainWorkHours: _this.volunteerWorkHoursReport.isDomainWork ? _this.volunteerWorkHoursReport.domainWorkHours : 0,
              domainWorkMinutes: _this.volunteerWorkHoursReport.isDomainWork ? _this.volunteerWorkHoursReport.domainWorkMinutes : 0,
              domainWorkNotes: _this.volunteerWorkHoursReport.isDomainWork ? _this.volunteerWorkHoursReport.domainWorkNotes : '',

              isOtherWork: _this.volunteerWorkHoursReport.isOtherWork,
              otherWorkHours: _this.volunteerWorkHoursReport.isOtherWork ? _this.volunteerWorkHoursReport.otherWorkHours : 0,
              otherWorkMinutes: _this.volunteerWorkHoursReport.isOtherWork ? _this.volunteerWorkHoursReport.otherWorkMinutes : 0,
              otherWorkNotes: _this.volunteerWorkHoursReport.isOtherWork ? _this.volunteerWorkHoursReport.otherWorkNotes : '',

              updatedAt: new Date(),
              updatedBy: JSON.parse(sessionStorage.getItem('DP_user')).id,
              createdAt: _this.volunteerWorkHoursReport.createdAt,
              createdBy: _this.volunteerWorkHoursReport.createdBy,

            })
              .then(function () {
                _this.$router.push({name: 'VolunteerWorkHoursReport'})
              })
              .catch(function (error) {
                // The document probably doesn't exist.
                console.error('Error updating work hour report: ', error)
              })
          } else {
            _this.$swal('Manjkajoči podatki', 'Preverite, če ste vnesli vse potrebne podatke!', 'error', {dangerMode: true})
          }
        })

      },

      addWorkHoursReport () {
        const _this = this

        this.$validator.validate().then(result => {
          console.log('result', result)
          if (result) {
            let ref = db.collection('volunteerWorkHoursReports').doc()
            ref.set({id: ref.id}) // set new document ID
              .then(() => {  // fetch the doc again and show its data
                ref.get().then(doc => {

                  _this.id = doc.data().id
                  _this.volunteerWorkHoursReport.createdAt = new Date();
                  _this.volunteerWorkHoursReport.createdBy = JSON.parse(sessionStorage.getItem('DP_user')).id;

                  _this.updateWorkHoursReport()

                })
              })
          } else {
            _this.$swal('Manjkajoči podatki', 'Preverite, če ste vnesli vse potrebne podatke!', 'error', {dangerMode: true})
          }
        })

      },
      deleteWorkHoursReportConfirmation () {
        const _this = this

        this.$swal({
          title: 'Opozorilo',
          text: 'Ali ste prepričani, da želite izbrisati ta zapis? Po potrditvi izbire ne bo več mogoče preklicati.',
          dangerMode: true,
          buttons: {
            cancel: {
              text: 'Prekliči',
              value: null,
              visible: true,
              className: '',
              closeModal: true,
            },
            confirm: {
              text: 'Izbriši',
              value: true,
              visible: true,
              className: '',
              closeModal: true
            }
          },
        })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteWorkHoursReport()

              case null:

                return

                break

              default:

            }
          })
      },
      deleteWorkHoursReport () {
        const _this = this

        db.collection('volunteerWorkHoursReports').doc(_this.id).delete()
          .then(function () {
            _this.$router.push({name: 'VolunteerWorkHoursReport'})
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error deleting work hour report: ', error)
          })
      },
      calculateDuration () {
        const _this = this

        let startTime = _this.moment(_this.volunteerWorkHoursReport.startTime, 'HH:mm')
        let endTime = _this.moment(_this.volunteerWorkHoursReport.endTime, 'HH:mm')

        _this.volunteerWorkHoursReport.endTime = endTime
        _this.volunteerWorkHoursReport.startTime = startTime

        console.log('startTime ', startTime)
        console.log('endTime ', endTime)

        _this.volunteerWorkHoursReport.duration = _this.moment.duration(_this.moment(endTime).diff(_this.moment(startTime))).format('HH:mm'), 'hours'

        //_this.duration = _this.moment.duration(_this.endTime.diff(_this.startTime));
        //console.log(_this.moment.duration(_this.moment(_this.volunteerWorkHoursReport.endTime, 'YYYY-MM-DDTHH:mm:ssZ').diff(_this.moment(_this.volunteerWorkHoursReport.startTime, 'YYYY-MM-DDTHH:mm:ssZ'))).asHours());

      },
      getReadableUser (userId) {
        const _this = this

        let userObj = _.filter(_this.users, {'id': userId})[0]
        if (userObj) {
          return userObj.first_name + ' ' + userObj.last_name
        } else {
          return 'n/a'
        }
      },

      getReadableProject (projectId) {
        const _this = this

        let projectObj = _.filter(_this.projects, {'id': projectId})[0]
        if (projectObj) {
          return projectObj.name
        } else {
          return 'n/a'
        }
      },

    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/user/EditVolunteerWorkHoursReport.vue